import './specimen-card.scss'

import { defineComponent, PropType } from "vue";
import { TranslateResult } from 'vue-i18n'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

import { SpecimenResource } from "@skinsoft/types";
import { itemTypeFormatters } from "@skinsoft/entity/src/item";
import { specimenSelectors } from '@skinsoft/selectors';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { Touchable } from "../touchable";
import { Media } from "../item-card/media";
import { Location } from '../item-card/location'

export const SpecimenCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sTouchable: Touchable,
        sMedia: Media,
        sLocation: Location,
    },
    props: {
        focused: {
            required: false,
        },
        specimen: {
            type: Object as PropType<SpecimenResource>,
            required: true,
        },
        readonly: {
            default: false,
            required: false,
        },
        displayType: {
            required: false
        }
    },
    template: require('./specimen-card.html'),
    data() {
        return {
            contentReady: false,
            encounteredError: false,
            validated: false,
            loadingIcon: faCircleNotch,
            specimenSelectors,
            descriptionReady: false,
            locationReady: false,
        }
    },
    computed: {
        readableCardType(): TranslateResult {
            return this.$t(itemTypeFormatters.getReadableType('specimen', 'specimen'))
        },
    },
    methods: {
        onDescriptionReady() {
            this.descriptionReady = true;
            this.processContentReady();
        },
        onLocationReady() {
            this.locationReady = true;
            this.processContentReady();
        },
        processContentReady() {
            this.contentReady = /*this.descriptionReady &&*/ this.locationReady;
        },
    },
})
